import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { NPCGenerator } from './components/NPCGenerator';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <NPCGenerator />
  </StrictMode>
);
